var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12","sm":"10","md":"8","lg":"6"}},[_c('payment-check')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }